import { render, staticRenderFns } from "./lock.vue?vue&type=template&id=2dfbfa43&"
import script from "./lock.vue?vue&type=script&lang=js&"
export * from "./lock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dfbfa43')) {
      api.createRecord('2dfbfa43', component.options)
    } else {
      api.reload('2dfbfa43', component.options)
    }
    module.hot.accept("./lock.vue?vue&type=template&id=2dfbfa43&", function () {
      api.rerender('2dfbfa43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/auth/lock.vue"
export default component.exports